/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassroomDisFolderItemViewModel } from "../types/ClassroomDisFolderItemViewModel.ts";

export const classroomDisFolderItemViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  classroomDisciplineId: z.optional(z.number().int()),
  parentFolderId: z.number().int().nullish(),
  title: z.string().nullish(),
}) as unknown as ToZod<ClassroomDisFolderItemViewModel>;
